import { Component, OnInit, ViewChild } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { LazyLoadEvent } from 'primeng/api'
import { Table } from 'primeng/table'
import { Observable } from 'rxjs'
import { distinctUntilChanged, map } from 'rxjs/operators'
import Swal from 'sweetalert2'
import { IServiceOrder } from '../../interface'
import {
  IOrderFilter,
  IServiceOrderState,
} from '../interface'
import { ServiceOrderService } from '../service-order.service'

@Component({
  selector: 'app-service-order-table',
  templateUrl: './service-order-table.component.html',
  styleUrls: ['./service-order-table.component.scss'],
})
export class ServiceOrderTableComponent implements OnInit {
  orders$: Observable<IServiceOrder[]> =
    this.serviceOrderState.sortedServiceOrders$
  ordersAmountTotal$: Observable<number> =
    this.serviceOrderState.ordersAmountTotal$
  uniqueFarmers$: Observable<number> = this.serviceOrderState.uniqueFarmers$
  limit$: Observable<number> = this.serviceOrderState.orderLimit$
  page$: Observable<number> = this.serviceOrderState.orderPage$
  total$: Observable<number> = this.serviceOrderState.currentServiceOrders$.pipe(
    map((orders) => orders.total)
  )
  selectedOrder$: Observable<IServiceOrder> =
    this.serviceOrderState.selectedOrder$
  filter$: Observable<IOrderFilter> = this.serviceOrderState.orderFilter$

  serviceOrderState$: Observable<IServiceOrderState> =
    this.serviceOrderState.currentServiceOrders$

  cols = [
    { field: 'date', header: 'Date created' },
    { field: 'code', header: 'Order Code' },
    { field: 'farmer_contact', header: 'farmer_contact' },
    { field: 'farmer_district', header: 'farmer_district' },
    { field: 'farmer_name', header: 'Name' },
    { field: 'service_name', header: 'service_name' },
    { field: 'service_provider', header: 'service_provider' },
    { field: 'unit', header: 'Unit' },
    { field: 'qty', header: 'Quantity' },
    { field: 'status', header: 'status' },
    { field: 'deviceModel', header: 'deviceModel' },
    { field: 'averageAccuracy', header: 'averageAccuracy' },
    { field: 'crop', header: 'Crop' },
    { field: 'payment', header: 'Payment' },
    { field: 'total_cost', header: 'Total Cost' },
    { field: 'farm_plan_name', header: 'Farm Plan Name' },
  ]

  @ViewChild('serviceOrders') serviceOrdersTable: Table

  constructor(private serviceOrderState: ServiceOrderService) { }

  ngOnInit() {
  }

  getData(event: LazyLoadEvent) {
    this.serviceOrderState.loadServiceOrders({
      page: event.first / event.rows + 1,
      limit: event.rows,
    })
  }

  selectOrder(order: IServiceOrder) {
    this.serviceOrderState.selectOrder(order)
  }

  onFilterUpdate(filter: IOrderFilter) {
    this.serviceOrderState.updateFilter(filter)
  }
  onDownload(event: any) {
    // this.serviceOrdersTable.exportCSV()
  }

  deleteOrder(order: IServiceOrder) {
    Swal.fire({
      title: 'Are you sure?',
      confirmButtonText: 'Yes',
      type: 'warning',
      text: 'you want to delete this order',
      showCancelButton: true,
    }).then((result) => {
      if (result.value) {
        this.serviceOrderState.deleteOrder(order.id)
      }
    })
  }

  handleRefreshTable() {
    const limit = this.serviceOrdersTable.rows
    const page = this.serviceOrdersTable.first / this.serviceOrdersTable.rows + 1
    this.serviceOrderState.loadServiceOrders({
      salt: Math.round(Date.now() / 1000) * 1000,
      page,
      limit,
    })
  }
}
